module.exports = __webpack_public_path__ + "static/media/btn_moon.5b3186d8.png";